
import { supabase } from "./client";
import { RequirementStatus } from "@/types/project";
import { toast } from "sonner";

export const getRequirementStatuses = async (projectId: string) => {
  try {
    const { data, error } = await supabase
      .from('requirement_status')
      .select('*')
      .eq('project_id', projectId);
    
    if (error) throw error;
    
    return data as RequirementStatus[];
  } catch (error) {
    console.error("Error fetching requirement statuses:", error);
    return [];
  }
};

export const updateRequirementStatus = async (
  projectId: string,
  requirementId: string,
  status: 'Incomplete' | 'In Progress' | 'Not Applicable' | 'Ready to Submit'
) => {
  try {
    // First check if a status record already exists
    const { data: existingStatus, error: checkError } = await supabase
      .from('requirement_status')
      .select('*')
      .eq('project_id', projectId)
      .eq('requirement_id', requirementId)
      .maybeSingle();
    
    if (checkError) throw checkError;
    
    let result;
    
    if (existingStatus) {
      // Update existing status
      result = await supabase
        .from('requirement_status')
        .update({ status })
        .eq('id', existingStatus.id)
        .select()
        .single();
    } else {
      // Insert new status
      result = await supabase
        .from('requirement_status')
        .insert({
          project_id: projectId,
          requirement_id: requirementId,
          status,
          user_id: (await supabase.auth.getUser()).data.user?.id
        })
        .select()
        .single();
    }
    
    if (result.error) throw result.error;
    
    return result.data as RequirementStatus;
  } catch (error) {
    console.error("Error updating requirement status:", error);
    toast.error("Failed to update requirement status");
    return null;
  }
};
